module.exports = __webpack_public_path__ + "static/media/INTRODUCTION TO EMPLOYER MANAGEMENT.b97fb7bd.png";